var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterspot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M487,302h27.927v49.287H487Z",
    transform: "translate(-487 -302)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M139.21,191h75.66v82.145H139.21Z",
    transform: "translate(-139.21 -191)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(-313.29 -2636.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "download_11_",
    "data-name": "download (11)",
    transform: "translate(225.299 2498.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M177.025,410.527H172.1a1.638,1.638,0,0,1-1.161-.481l-1.643-1.643a1.643,1.643,0,1,1,2.323-2.323l1.161,1.161h3.568l1.161-1.161a1.643,1.643,0,1,1,2.323,2.323l-1.643,1.643a1.641,1.641,0,0,1-1.161.481Z",
    transform: "translate(-23.029 -166.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(216.424 215.644)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M509.417,321.8l-1.058-2.116v-1.255a1.643,1.643,0,1,0-3.285,0v1.643a1.645,1.645,0,0,0,.173.735l1.643,3.286a1.643,1.643,0,0,0,1.47.909,3.29,3.29,0,0,1,3.286,3.286v16.428A3.29,3.29,0,0,1,508.359,348H495.216a3.29,3.29,0,0,1-3.286-3.286V328.291A3.289,3.289,0,0,1,495.216,325a1.643,1.643,0,0,0,1.47-.909l1.189-2.377h3.913a1.643,1.643,0,1,0,0-3.285H498.5v-3.286h14.786a1.643,1.643,0,0,0,1.619-1.914c-.075-.459-1.962-11.231-9.834-11.231h-11.5a1.638,1.638,0,0,0-1.161.481l-1.643,1.643a1.638,1.638,0,0,0-.481,1.161v1.643h-1.643a1.643,1.643,0,0,0,0,3.285h1.643v1.643a1.635,1.635,0,0,0,.481,1.161l1.643,1.643a1.641,1.641,0,0,0,1.161.481h1.643v4.541l-1.058,2.116a6.583,6.583,0,0,0-5.513,6.486v16.428a6.577,6.577,0,0,0,6.571,6.571h13.143a6.577,6.577,0,0,0,6.571-6.571V328.286a6.582,6.582,0,0,0-5.513-6.486Zm-15.844-10.623v-5.211l.68-.68h10.82c3.545,0,5.342,4.069,6.113,6.571H494.253Z",
    transform: "translate(-487.002 -302.002)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M530.563,433.546a6.571,6.571,0,1,1,6.571-6.571A6.578,6.578,0,0,1,530.563,433.546Zm0-9.857a3.286,3.286,0,1,0,3.286,3.286A3.29,3.29,0,0,0,530.563,423.689Z",
    transform: "translate(-299.355 -178.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(139.21 191)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M213.137,233.423a1.642,1.642,0,0,0-1.643,1.643v33.156a1.644,1.644,0,0,1-1.643,1.643H144.138a1.644,1.644,0,0,1-1.643-1.643v-3.286H208.21a1.643,1.643,0,0,0,0-3.285H142.5V195.936a1.644,1.644,0,0,1,1.643-1.643h32.856a18.4,18.4,0,0,1,8.684,2.491l20.715,12.949a9.5,9.5,0,0,1,1.515,1.214,1.643,1.643,0,1,0,2.264-2.381,12.619,12.619,0,0,0-2.039-1.62L187.42,194a21.409,21.409,0,0,0-10.425-2.99H144.137a4.935,4.935,0,0,0-4.928,4.928v72.283a4.935,4.935,0,0,0,4.928,4.929h65.714a4.935,4.935,0,0,0,4.928-4.929V235.066a1.642,1.642,0,0,0-1.643-1.643Z",
    transform: "translate(-139.209 -191.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M229.594,253.461H170.451a1.642,1.642,0,0,1-1.643-1.643V222.246a1.642,1.642,0,0,1,1.643-1.643h29.572a15.176,15.176,0,0,1,6.942,1.991l20.713,12.947a8.258,8.258,0,0,1,3.184,4.289,1.643,1.643,0,0,1-3.12,1.03,4.985,4.985,0,0,0-1.806-2.535l-20.713-12.947a11.958,11.958,0,0,0-5.2-1.49H172.095v26.284h57.5a1.643,1.643,0,1,1,0,3.285Z",
    transform: "translate(-23.027 -23.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M462.327,293.768a1.638,1.638,0,0,1-1.161-.481L457.88,290a1.643,1.643,0,1,1,2.323-2.323l3.286,3.286a1.643,1.643,0,0,1-1.161,2.8Z",
    transform: "translate(-247.545 -74.838)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M459.042,352.968a1.643,1.643,0,0,1-1.161-2.8l3.286-3.286a1.643,1.643,0,1,1,2.323,2.323l-3.286,3.286a1.638,1.638,0,0,1-1.161.481Z",
    transform: "translate(-247.546 -120.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M441.774,327.488h-4.928a1.643,1.643,0,1,1,0-3.285h4.928a1.643,1.643,0,1,1,0,3.285Z",
    transform: "translate(-230.278 -103.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(156.991 204.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(171.991 215.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(184.991 212.573)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterspot);
export default __webpack_public_path__ + "static/media/waterspot.f2ce8b28d652fe68128bc136dbb81937.svg";
export { ForwardRef as ReactComponent };